import { hasFlag } from 'country-flag-icons'

export class CountryFlag {

	/*
	 * Init the handler
	 *
	 */

    constructor() {
        document.querySelectorAll('div.ed-country-flag').forEach(flag => {
            let country = flag.dataset.country
			let flag_url;
			let flag_icon;

            if( hasFlag(country) ) {
				let title = flag.dataset.title;
				let base = 'https://purecatamphetamine.github.io/country-flag-icons/3x2/';
				 flag_url = base + country +'.svg';
				flag_icon = '<img class="country-flag lazyloaded" alt="'+ title +'" src="'+ flag_url +'">';
            } else{
				flag_icon = '<img class="country-flag lazyloaded" alt="global" src="/wp-content/themes/tungsten/src/assets/images/SVG/global.svg">';
			}
			let wrapper = flag.dataset.wrapper;
			if(wrapper) {
				flag_icon = '<div class="' + wrapper + '">' + flag_icon + '</div>'
			}
			flag.innerHTML = flag_icon
        });
    }
}
